webpackJsonp([0],[
/* 0 */
/* no static exports found */
/* all exports used */
/*!******************!*\
  !*** ./index.js ***!
  \******************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(/*! ./App */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),
/* 1 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/zeit/23acc284/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./App.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      projects: [{
        title: 'markvis',
        bio: 'make visualization in markdown',
        img: './markvis-preview.png',
        link: 'https://github.com/geekplux/markvis'
      }, {
        title: 'netjsongraph.js',
        bio: 'To visualize network topology using the NetJSON format',
        img: './netjsongraph-preview.png',
        link: 'https://github.com/netjson/netjsongraph.js'
      }, {
        title: 'Typing',
        bio: 'a pure and fresh Hexo theme',
        img: './typing-preview.png',
        link: 'https://github.com/geekplux/hexo-theme-typing'
      }, {
        title: 'Basic visualization in Unity',
        bio: 'Basic 2D visualization in Unity',
        img: './unity-preview.png',
        link: 'https://github.com/geekplux/Basic-Visualization-in-Unity'
      }, {
        title: 'markdown-it-fence',
        bio: 'fence customize plugin for markdown-it',
        link: 'https://github.com/geekplux/markdown-it-fence'
      }]
    };
  }
});

/***/ }),
/* 2 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17d57b0e","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3 */
/* no static exports found */
/* exports used: default */
/*!*****************!*\
  !*** ./App.vue ***!
  \*****************/
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./~/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-17d57b0e","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 2)
}
var Component = __webpack_require__(/*! ./~/vue-loader/lib/component-normalizer */ 4)(
  /* script */
  __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/zeit/23acc284/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./~/vue-loader/lib/selector?type=script&index=0!./App.vue */ 1),
  /* template */
  __webpack_require__(/*! !./~/vue-loader/lib/template-compiler/index?{"id":"data-v-17d57b0e","hasScoped":false}!./~/vue-loader/lib/selector?type=template&index=0!./App.vue */ 5),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-17d57b0e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./App.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "projects"
  }, _vm._l((_vm.projects), function(p) {
    return _c('div', {
      staticClass: "project panel"
    }, [_c('h3', {
      staticClass: "project-title title"
    }, [_vm._v(_vm._s(p.title))]), _vm._v(" "), _c('p', {
      staticClass: "project-bio"
    }, [_vm._v(_vm._s(p.bio))]), _vm._v(" "), (p.link) ? _c('a', {
      staticClass: "project-link",
      attrs: {
        "href": p.link
      }
    }, [_vm._v(_vm._s(p.link))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "project-badges"
    }), _vm._v(" "), (p.img) ? _c('div', {
      staticClass: "project-image"
    }, [_c('img', {
      attrs: {
        "alt": "",
        "src": p.img
      }
    })]) : _vm._e()])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Project")]), _vm._v(" "), _c('h2', [_vm._v("Do some cool stuff")]), _vm._v(" "), _c('h2', [_vm._v("做一点微小的贡献")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "links"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "http://geekplux.com/archives"
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://geekplux.com/wiki"
    }
  }, [_vm._v("Wiki")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/geekplux"
    }
  }, [_vm._v("GitHub")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://about.geekplux.com"
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://donate.geekplux.com"
    }
  }, [_vm._v("Donate")])])])
}]}

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/* no static exports found */
/* all exports used */
/*!************************!*\
  !*** multi ./index.js ***!
  \************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /zeit/23acc284/index.js */0);


/***/ })
],[8]);


// WEBPACK FOOTER //
// client.22a2ed8c.js